<script setup>

import {useClearShipperContact} from "@/composables/bookings/useClearShipperContact";
import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import {useMapConsigneeContact} from "@/composables/bookings/useMapConsigneeContact";

import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown.vue";
import StaticTooltip from "@/components/common/other/StaticTooltip.vue";

const emits = defineEmits(['addNewConsigneeContact', 'editConsigneeContact']);

const props = defineProps({

  modelValue: {},
  updateConsigneeContacts: 0,
  validationViewModel: {}
})

function mapSelectedConsigneeContactDetail(contact) {

  useMapConsigneeContact(contact, props.modelValue);

}
</script>

<template>
  <div class="global-contact-select">
    <div class="cmp-multi-booking_address-layout">
      <MultiSearchDropDown
          :key="updateConsigneeContacts"
          @select="mapSelectedConsigneeContactDetail"
          @clear="useClearShipperContact(props.modelValue)"
          placeholder="Select..."
          :maxLength="50"
          :width="330"
          :labelWidth="85"
          :requiredField="useGetValidatedFields( props.modelValue.metaData.validatedFields, 'consigneeContactFullName' )"
          :allowCustomValue="false"
          :disableFilter="true"
          :selectPrimitiveValue="true"
          v-model:validation-fail="validationViewModel"
          label="Contacts"
          :label-top="true"
          v-model="props.modelValue.consignee.consigneeContactFullName"
          :data-source="props.modelValue.consignee.consigneeContacts">
      </MultiSearchDropDown>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 240px;">
            Create new contacts for the the selected Consignee
          </div>
        </template>
        <img class="global-icon-button"
             v-if="modelValue.consignee.consigneeName"
             @click="emits('addNewConsigneeContact')"
             height="22"
             width="22"
             src="@/assets/icons/akar/akar-icons--circle-plus.png">
      </StaticTooltip>
      <StaticTooltip :icon="false">
        <template #content>
          <div style="width: 300px;">
            Edit the Shipper address, you may also create a new Shipper for your records if you have chosen
            to use un saved address information previously.
          </div>
        </template>
        <img class="global-icon-button"
             @click="emits('editConsigneeContact')"
             v-if="modelValue.consignee.consigneeContactFullName"
             height="24" width="24"
             src="@/assets/icons/akar/akar-icons--edit.png">
      </StaticTooltip>
    </div>
    <div class="cmp-multi-booking_contact-container">
      <div class="cmp-multi-booking_selected-address">
        <div v-if="modelValue.consignee.consigneeContactId === 0 && modelValue.consignee.consigneeContactFullName"
             style="position: absolute; top: 12px; right: 5px">
          <img title="This contact is not saved in your system."
               height="16"
               width="16"
               src="@/assets/icons/unsaved.png">
        </div>
        <div v-if="props.modelValue.consignee.consigneeContactFullName.trim().length > 0">
          <div class="cmp-multi-booking_address-heading">Full Name</div>
          <div>{{ props.modelValue.consignee.consigneeContactFullName }}</div>
          <div class="cmp-multi-booking_address-heading">Telephone</div>
          <div>{{ props.modelValue.consignee.consigneeContactPhone || 'n/a' }}</div>
          <div class="cmp-multi-booking_address-heading">Email</div>
          <div>{{ props.modelValue.consignee.consigneeContactEmail || 'n/a' }}</div>
          <div class="cmp-multi-booking_address-heading">Department</div>
          <div>{{ props.modelValue.consignee.consigneeContactDepartment || 'n/a' }}</div>
        </div>
        <div v-if="props.modelValue.consignee.consigneeContactFullName.trim().length === 0" class="cmp-multi-booking_address-placeholder-wrapper">
          <div style="display:flex; align-items: center">
            <img height="22" width="22" src="@/assets/icons/user_small.png">
            <span>Contact Information</span>
          </div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p1"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p2"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p3"></div>
          <div class="cmp-multi-booking_address-placeholder cmp-multi-booking_a-p4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/css/booking/multi-booking.scss';
</style>